/**
 * Following the duck pattern, actions, constants and reducers are in the same file called module.js
 *
 * See: https://github.com/erikras/ducks-modular-redux
 *
 */
import { call, put, takeEvery } from 'redux-saga/effects'
import { getAPIUrl, request } from 'shared/services/networking'

export const GET_PROCESS_OVERVIEW_REQUEST = 'ProcessOverview/GET_PROCESS_OVERVIEW_REQUEST'
export const GET_PROCESS_OVERVIEW_SUCCESS = 'ProcessOverview/GET_PROCESS_OVERVIEW_SUCCESS'
export const GET_PROCESS_OVERVIEW_ERROR = 'ProcessOverview/GET_PROCESS_OVERVIEW_ERROR'

export function getProcessOverviewRequest (id) {
  return {
    type: GET_PROCESS_OVERVIEW_REQUEST,
    payload: id
  }
}

export function getProcessOverviewSuccess (article) {
  return {
    type: GET_PROCESS_OVERVIEW_SUCCESS,
    payload: article
  }
}

export function getProcessOverviewError (error) {
  return {
    type: GET_PROCESS_OVERVIEW_ERROR,
    payload: error
  }
}

export function * getProcessOverview (action) {
  const config = {
    method: 'get',
    url: `${getAPIUrl()}/widget/process-overview/${action.payload}/`
  }
  try {
    const article = yield call(request, config)
    yield put(getProcessOverviewSuccess(article))
  } catch (error) {
    yield put(getProcessOverviewError(error))
  }
}

export function * getProcessOverviewSaga () {
  yield takeEvery(GET_PROCESS_OVERVIEW_REQUEST, getProcessOverview)
}

const initialState = {
  error: null,
  processOverview: null
}

/**
 * Following the duck pattern, the module.js file should export a reducer as a default function
 */
export function reducer (state = initialState, action) {
  switch (action.type) {
    case GET_PROCESS_OVERVIEW_ERROR:
      return {
        ...state,
        error: action.payload
      }
    case GET_PROCESS_OVERVIEW_REQUEST:
      return {
        ...state,
        processOverview: null,
        error: null
      }
    case GET_PROCESS_OVERVIEW_SUCCESS:
      return {
        ...state,
        processOverview: action.payload
      }
    default:
      return state
  }
}

export default reducer
